import { ProjectModel } from "../models/ProjectModel"
import { ProjectEarlierModel } from "../models/ProjectEarlierModel"
import ProjectCard from "./List/ProjectCard"
import ProjectEarlier from "./List/ProjectEarlier"
import ListTemplate from "./List/ListTemplate"

function Project() {
    return (
        <div>
            <big className="section-header">Projects</big>
            <ListTemplate component={ProjectCard} data={ProjectModel} sectionTitle="Selected Work"/>
            <ListTemplate component={ProjectEarlier} data={ProjectEarlierModel} sectionTitle="Earlier & Personal"/>
        </div>
    )
}

export default Project
